import { Component, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { InvestmentWizardService } from '../services/investment-wizard-service.service';
import { SessionStorageService } from '../../services/session-storage.service';
import {
  SortDescriptor,
  State,
  GroupDescriptor,
  CompositeFilterDescriptor,
} from '@progress/kendo-data-query';
import { AccountsService } from '../../account-management/services/accounts-service.service';
import { CompareDialogComponent } from '../../compare-dialog/compare-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { saveAs } from '@progress/kendo-file-saver';
import { getFilterMenuText } from '../../lib/rb-grid-lib';
import { EnvironmentService } from '../../services/environment.service';
import { Platform } from '@angular/cdk/platform';
import { RightBridgeApiService } from '../../services/right-bridge-api.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CalculateCostValueDialogComponent } from '../calculate-cost-value-dialog/calculate-cost-value-dialog.component';
import { GenerateAlternativesDialogComponent } from '../generate-alternatives-dialog/generate-alternatives-dialog.component';

import { FormsModule } from '@angular/forms';
import { RbGridComponent } from '../../shared-components/rb-grid/rb-grid.component';
import { NgxLoadingModule } from 'ngx-loading';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ManageFiltersComponent } from '../../manage-filters/manage-filters.component';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-product-grid',
  templateUrl: './product-grid.component.html',
  styleUrls: ['./product-grid.component.scss'],
  imports: [
    FormsModule,
    ManageFiltersComponent,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    NgxLoadingModule,
    RbGridComponent,
  ],
})
export class ProductGridComponent implements OnInit, OnDestroy {
  private acctSrvc = inject(AccountsService);
  private iws = inject(InvestmentWizardService);
  private location = inject(Location);
  private params = inject(ActivatedRoute);
  private ss = inject(SessionStorageService);
  dialog = inject(MatDialog);
  private envSvc = inject(EnvironmentService);
  private pltfrm = inject(Platform);
  private rbs = inject(RightBridgeApiService);
  private snacky = inject(MatSnackBar);

  public filter: CompositeFilterDescriptor = { logic: 'and', filters: [] };
  public group: GroupDescriptor[] = [];
  public hidden: string[] = [];
  public pageSize = 25;
  public pageSizeOptions = [25, 50, 75, 100];
  public skip = 0;
  public sort: SortDescriptor[] = [];
  public getFilterMenuText = getFilterMenuText;

  @ViewChild('dropdownSelector', { static: false }) dropdownSelector;
  @ViewChild(RbGridComponent) rbGrid: RbGridComponent;

  baseUrl: string;
  compareChecked = {};
  compareList = [];
  dateFilters = [];
  dropdownFilters = [];
  environment: any;
  externalFilters = [];
  ogFilterData = {};
  filterData = {};
  filterOptions = {};
  gridColumns;
  gridView = 'product';
  hideGrid = false;
  intervalVar: Subscription;
  loading;
  ogData;
  ogExternalFilters = [];
  ogHeaders;
  ogHidden = [];
  org;
  paramsSubscription;
  programToFilter: string;
  range = { start: null, end: null };
  resetFilters = false;
  rights: string[];
  searchFilters = [];
  showNewProfile = false;
  unitSettings;
  gridData = {
    data: null,
    headers: null,
    subHead: new Map(),
    total: 0,
  };
  state: State = {
    filter: this.filter,
    sort: this.sort,
    skip: this.skip,
    take: this.pageSize,
  };
  singleProgram: any;
  colFiltersChanged: {
    values: any;
    dataField: string;
    filterData: string;
    currentFilters: any;
  };
  gridConfig = {
    title: 'Product Shelf',
    gridName: 'IWProductShelf',
    showGridFilters: true,
    showFilterManager: true,
    manualSearch: false,
    searchButtonText: 'Search Results',
    downloadGridButton: true,
    downloadGridButtonProps: {
      icon: 'cloud_download',
      text: 'Export Product Shelf',
      action: 'application/csv',
    },
    gridActionColumn: true,
    selectableRows: true,
    gridActions: [
      {
        icon: 'insert_drive_file',
        color: 'primary',
        text: 'Download Factsheet',
        action: this.dlFundFactSheet.bind(this),
      },
      {
        icon: 'open_in_new',
        color: 'primary',
        text: 'Open Prospectus',
        action: this.getProspectus.bind(this),
        show: this.showProspectus.bind(this),
      },
    ],
    showGridColumnFilters: true,
    conditionalSearch: true,
    preselectedFilters: null,
    rowSelector: 'FundID',
    compareRows: true,
    calcFields: {
      icon: 'payments',
      color: 'primary',
      text: 'Calculate Cost/Value',
      action: this.calcFields.bind(this),
    },
    changeProgram: this.changeProgram.bind(this),
    reorderable: true,
  };
  programName: any;
  programOptions = [];
  programChooser = true;
  templateDataToUse: any;

  ngOnInit(): void {
    this.rights = this.ss.get('rights') || [];
    this.environment = this.envSvc.get();
    this.baseUrl = this.environment.apiBase;
    if (this.rights && this.rights.includes('HOProductShelfCSV')) {
      this.gridConfig.downloadGridButton = true;
    }
    this.org = this.ss.get('globals') ? this.ss.get('globals').firmId : null;
    this.paramsSubscription = this.params.params.subscribe(params => {
      if (params.program) {
        this.programToFilter = decodeURIComponent(params.program);
        this.programName = decodeURIComponent(params.program);
        this.sendProgramOut();
      }
      this.location.go(`iw/product-shelf`);
    });
    if (!this.programToFilter) {
      this.getPrograms();
    }
  }

  ngOnDestroy(): void {
    if (this.paramsSubscription) {
      this.paramsSubscription.unsubscribe();
    }
  }

  getGridSetup(setupParam?) {
    return this.iws.getProductGridSetup(setupParam);
  }

  getPrograms() {
    this.programOptions = [];
    this.loading = true;
    this.acctSrvc.programSearch(true).subscribe({
      next: res => {
        if (res.results.length > 0) {
          if (res.results.length === 1) {
            this.programName = res.results[0].DisplayName;
            this.loading = false;
            this.sendProgramOut(true);
          } else {
            res.results.map(prog => {
              this.programOptions.push(prog.DisplayName);
            });
            this.loading = false;
          }
        } else {
          console.error('Could not load programs.');
          this.loading = false;
        }
      },
      error: () => {
        console.error('Could not load programs.');
        this.loading = false;
      },
    });
  }

  changeProgram() {
    this.gridConfig['initialProgram'] = '';
    this.programChooser = true;
    this.templateDataToUse = null;
  }

  sendProgramOut(disableProgamFilter = false) {
    this.gridConfig['initialProgram'] = this.programName;
    this.gridConfig['disableProgramFilter'] = disableProgamFilter;
    this.programChooser = false;
    this.templateDataToUse = null;
  }

  getGridData(queryData?, responseType = 'application/json') {
    if (typeof queryData === 'string') {
      queryData = JSON.parse(queryData);
    }
    if (responseType === 'application/csv') {
      delete queryData['skip'];
      delete queryData['take'];
    }
    const reqData = { queryData: queryData, resType: responseType };

    this.ss.remove('IWProductShelfFilters');

    return this.iws.getProductGrid(reqData);
  }

  compare() {
    const tableDef = {
      id: 'compare1',
      name: 'compare1',
      label: 'table label',
      type: 'vert',
      header: {
        title: '',
        bullets: [],
      },
      footer: {
        footnotes: [],
      },
      columns: [
        {
          var: 'header1',
          label: 'Label',
        },
        {
          var: 'header1',
          label: 'Fund',
        },
      ],
      rows: [
        {
          var: 'Symbol',
          label: 'Symbol',
        },
        {
          var: 'Name',
          label: 'Name',
        },
        {
          var: 'RBCategory',
          label: 'Category',
        },
        {
          var: 'ExpenseRatio',
          label: 'Expense Ratio',
        },
        {
          var: 'RewardToSemiVarianceRatio',
          label: 'Semivariance',
        },
        {
          var: 'TrailingReturnY3',
          label: '3 Yr Trailing Return',
        },
        {
          var: 'FrontLoadFeeValue1',
          label: 'Max Upfront Sales Charge',
        },
        {
          var: 'FrontLoadSchedule',
          label: 'Front Load Schedule',
        },
        {
          var: 'CDSCSchedule',
          label: 'CDSC Schedule',
        },
        {
          var: '3YearStandardDeviation',
          label: '3 Yr Std Deviation',
        },
        {
          var: 'TrailingReturnYTD',
          label: 'YTD Trailing Return',
        },
        {
          var: 'TrailingReturnY1',
          label: '1 Yr Trailing Return',
        },
        {
          var: 'TrailingReturnY5',
          label: '5 Yr Trailing Return',
        },
        {
          var: 'TrailingReturnY10',
          label: '10 Yr Trailing Return',
        },
        {
          var: 'ThirtyDaySECYield',
          label: '30-Day SEC Yield',
        },
        {
          var: 'AverageCreditQuality',
          label: 'Bond Credit Quality',
        },
        {
          var: 'AverageEffectiveDuration',
          label: 'Bond Duration',
        },
        {
          var: 'FundType',
          label: 'Fund Type',
        },
        {
          var: 'RedemptionFeeSchedule',
          label: 'Redemption Fee Schedule',
        },
        {
          var: 'InceptionDate',
          label: 'Inception Date',
        },
        {
          var: 'TurnoverRatio',
          label: 'Turnover Ratio',
        },
        {
          var: 'TradeStatus',
          label: 'Trade Status',
        },
        {
          var: 'ClosedToNewInvestors',
          label: 'Closed to New Investors',
        },
      ],
    };

    const compareFunds = this.rbGrid.selectedTradeList;

    compareFunds.map(fundData => {
      // Truncate the timestamp off of date strings
      if (fundData['InceptionDate']) {
        fundData['InceptionDate'] = fundData['InceptionDate'].split(' ')[0];
      }
    });
    const compareData = {
      funds: compareFunds,
      header: 'Compare Funds',
      tables: [tableDef],
      type: 'iwGrid',
      iwProductShelf: true,
    };

    const dialogRef = this.dialog.open(CompareDialogComponent, {
      panelClass: 'compare-dialog',
      height: '90vh',
      width: '90vw',
      maxHeight: '90vh',
      maxWidth: '90vw',
      data: compareData,
      autoFocus: false,
    });

    dialogRef.afterClosed();
  }

  dlFundFactSheet(ev, dataItem) {
    this.loading = true;
    const iosSafari =
      this.pltfrm.IOS ||
      (navigator?.['userAgentData']?.platform === 'macOS' &&
        navigator.maxTouchPoints > 1);

    const payload = {
      ReportType: 'template',
      UIConfig: 'iw-funddetails',
      UnitID: this.ss.get('firm'),
      parameters: { ticker: dataItem.FundID },
    };

    this.rbs.getCustomReport(payload, 'iw').subscribe(data => {
      const filename = `${dataItem.FundID}-${dataItem.ProgramName}-Factsheet.pdf`;

      let fileData;
      const reader = new FileReader();
      reader.readAsDataURL(data);
      reader.onloadend = () => {
        fileData = reader.result;
        saveAs(fileData, filename, {
          proxyURL: `${this.baseUrl}/util/proxy`,
          proxyTarget: '_self',
          forceProxy: iosSafari,
        });
        this.loading = false;
      };
    });
  }

  selectTemplate(ev) {
    this.templateDataToUse = ev.value;
  }

  sendTemplateOut() {
    this.programName = this.templateDataToUse.FilterData.filters.find(
      dataItem => dataItem.field === 'ProgramName'
    ).value;

    this.gridConfig.preselectedFilters = this.templateDataToUse;

    this.gridConfig['initialProgram'] = this.programName;
    this.programChooser = false;
  }

  showProspectus() {
    return this.rights.includes('ProspectusInIWProductShelf');
  }

  getProspectus(ev, dataItem) {
    this.iws.getProspectus(dataItem.FundID).subscribe({
      next: (res: {
        data: {
          Ticker: string;
          CIK: string;
          ProspectusUrl: string;
        };
      }) => {
        try {
          if (
            !res?.data?.ProspectusUrl ||
            typeof res.data.ProspectusUrl !== 'string'
          ) {
            throw new Error('Invalid prospectus url structure');
          }
          const extUrl = new URL(res.data.ProspectusUrl);
          window.open(extUrl, '_blank');
        } catch (error) {
          console.error('Error processing prospectus response:', error);
          this.snacky.open(
            `An unexpected error occurred. Please try again later or contact your Home Office.`,
            'Close',
            {
              duration: 10000,
            }
          );
        }
      },
      error: err => {
        switch (err.status / 100) {
          case 4:
            this.snacky.open(
              `Prospectus not available for selected item.`,
              'Close',
              {
                duration: 10000,
              }
            );
            break;
          case 5:
            this.snacky.open(
              `Prospectuses are temporarily unavailable. Please try again later or contact your Home Office.`,
              'Close',
              {
                duration: 10000,
              }
            );
            break;
          default:
            break;
        }
      },
    });
  }

  calcFields() {
    const dialogRef = this.dialog.open(CalculateCostValueDialogComponent, {
      panelClass: 'calculate-dialog',
      width: '50vw',
      maxHeight: '70vh',
      maxWidth: '70vw',
    });

    dialogRef.afterClosed().subscribe(resultData => {
      const calcFieldsCols = [
        'HypotheticalRateOfReturn',
        'ShareClassConversion',
        'TimeHorizon',
        'InvestmentAmount',
      ];
      calcFieldsCols.forEach(fieldItem => {
        if (!this.rbGrid.searchFilters.includes(fieldItem)) {
          this.rbGrid.searchFilters.push(fieldItem);
        }
      });
      if (
        !this.rbGrid.filter.filters.find(
          filterItem => filterItem['field'] === 'HypotheticalRateOfReturn'
        )
      ) {
        this.rbGrid.filter.filters.push({
          field: 'HypotheticalRateOfReturn',
          operator: 'contains',
          value: `${resultData?.['rateOfReturn']}`,
        });
      } else {
        this.rbGrid.filter.filters.find(
          filterItem => filterItem['field'] === 'HypotheticalRateOfReturn'
        )['value'] = `${resultData['rateOfReturn']}`;
      }
      if (
        !this.rbGrid.filter.filters.find(
          filterItem => filterItem['field'] === 'ShareClassConversion'
        )
      ) {
        this.rbGrid.filter.filters.push({
          field: 'ShareClassConversion',
          operator: 'contains',
          value: `${resultData['conversionTimeFrame']}`,
        });
      } else {
        this.rbGrid.filter.filters.find(
          filterItem => filterItem['field'] === 'ShareClassConversion'
        )['value'] = `${resultData['conversionTimeFrame']}`;
      }
      if (
        !this.rbGrid.filter.filters.find(
          filterItem => filterItem['field'] === 'TimeHorizon'
        )
      ) {
        this.rbGrid.filter.filters.push({
          field: 'TimeHorizon',
          operator: 'contains',
          value: `${resultData['timeHorizon']}`,
        });
      } else {
        this.rbGrid.filter.filters.find(
          filterItem => filterItem['field'] === 'TimeHorizon'
        )['value'] = `${resultData['timeHorizon']}`;
      }
      if (
        !this.rbGrid.filter.filters.find(
          filterItem => filterItem['field'] === 'InvestmentAmount'
        )
      ) {
        this.rbGrid.filter.filters.push({
          field: 'InvestmentAmount',
          operator: 'contains',
          value: `${resultData['investmentAmount']}`,
        });
      } else {
        this.rbGrid.filter.filters.find(
          filterItem => filterItem['field'] === 'InvestmentAmount'
        )['value'] = `${resultData['investmentAmount']}`;
      }
      if (Object.prototype.hasOwnProperty.call(resultData, 'orderBy')) {
        this.sort = [
          {
            dir:
              resultData['orderBy'] === 'TotalEstimatedCost' ? 'asc' : 'desc',
            field: resultData['orderBy'],
          },
        ];
      }
      this.state.sort = [...this.sort];
      this.rbGrid.hiddenExtColsShow();
      this.rbGrid.getGridData();
    });
  }

  disableCompare() {
    return this.rbGrid?.selectedTradeList?.length < 2;
  }

  generateAlternatives() {
    let dialogRef = this.dialog.open(GenerateAlternativesDialogComponent, {
      data: {
        symbol: this.rbGrid.selectedTradeList[0].FundID,
        program: this.rbGrid.selectedTradeList[0].ProgramName,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      dialogRef = null;
    });
  }

  disableAlternatives() {
    return (
      this.rbGrid?.selectedTradeList?.length < 1 ||
      this.rbGrid?.selectedTradeList?.length > 1
    );
  }
}
